export const routeSegments = {
  view: "view",
  create: "create",
  wildcard: "*",
  previousDeal: "previousdeal",
  edit: {
    createDeal: "edit/:promotionId",
    uploadFlyer: "edit/:flyerId",
    user: "edit/:userId",
    merchant: "edit/:merchantId",
    store: "edit/:storeId",
    role: "edit/:roleId",
    flyerScraper: "edit/:flyerScraperId",
    image: "edit/:imageId",
    banner: "edit/:bannerId",
    preferenceCuisine: "edit/:cuisineId",
    preferenceWatchItem: "edit/:watchItemId",
    figmaTemplate: "edit/:figmaTemplateId",
    dealSpotlight: "edit/:spotlightId",
  },
} as const;

export const routes = {
  core: {
    root: "/",
    login: "/login",
    signup: "/signup",
    dashboard: "/dashboard",
    createTabs: "/create",
    wildcard: "/*",
    viewRedirect: "/view",
  },
  camera: {
    pattern: "/camera/:storeId",
    success: "/camera/success",
    byStoreId: (storeId: string) => `/camera/${storeId}`,
  },
  storeUploadImage: {
    base: "/storeuploadimage",
    pattern: "/storeuploadimage/:storeId",
    byStoreId: (storeId: string) => `/storeuploadimage/${storeId}`,
  },
  createFlyer: {
    base: "/createflyer",
    pattern: "/createflyer/:flyerItemListId",
    byId: (flyerItemListId: string) => `/createflyer/${flyerItemListId}`,
  },
  createCoupon: {
    base: "/createcoupon",
  },
  uploadFlyer: {
    base: "/uploadflyer",
    view: "/uploadflyer/view",
    create: "/uploadflyer/create",
    edit: "/uploadflyer/edit/:flyerId",
    editById: (flyerId: string) => `/uploadflyer/edit/${flyerId}`,
  },
  adminFlyerReview: {
    base: "/admin-flyer",
    pattern: "/admin-flyer/:flyerId/review",
    byId: (flyerId: string) => `/admin-flyer/${flyerId}/review`,
  },
  uploadMenu: {
    base: "/uploadmenu",
  },
  user: {
    base: "/user",
    view: "/user/view",
    create: "/user/create",
    edit: "/user/edit/:userId",
    editById: (userId: string) => `/user/edit/${userId}`,
  },
  merchant: {
    base: "/merchant",
    view: "/merchant/view",
    create: "/merchant/create",
    edit: "/merchant/edit/:merchantId",
    editById: (merchantId: string) => `/merchant/edit/${merchantId}`,
  },
  store: {
    base: "/store",
    view: "/store/view",
    create: "/store/create",
    edit: "/store/edit/:storeId",
    editById: (storeId: string) => `/store/edit/${storeId}`,
  },
  role: {
    base: "/role",
    view: "/role/view",
    create: "/role/create",
    edit: "/role/edit/:roleId",
    editById: (roleId: string) => `/role/edit/${roleId}`,
  },
  permission: {
    base: "/permission",
    view: "/permission/view",
  },
  tag: {
    base: "/tag",
    view: "/tag/view",
  },
  dealSpotlights: {
    base: "/deal-spotlights",
    view: "/deal-spotlights/view",
    create: "/deal-spotlights/create",
    edit: "/deal-spotlights/edit/:spotlightId",
    editById: (spotlightId: string) => `/deal-spotlights/edit/${spotlightId}`,
  },
  notification: {
    base: "/notification",
    view: "/notification/view",
    create: "/notification/create",
  },
  flyerScraper: {
    base: "/flyerScraper",
    view: "/flyerScraper/view",
    create: "/flyerScraper/create",
    edit: "/flyerScraper/edit/:flyerScraperId",
    editById: (flyerScraperId: string) =>
      `/flyerScraper/edit/${flyerScraperId}`,
  },
  elasticTrigger: {
    base: "/elasticTrigger",
    view: "/elasticTrigger/view",
  },
  feedback: {
    base: "/feedBack",
    view: "/feedBack/view",
  },
  unit: {
    base: "/unit",
    view: "/unit/view",
  },
  cache: {
    base: "/cache",
    view: "/cache/view",
  },
  image: {
    base: "/image",
    view: "/image/view",
    create: "/image/create",
    edit: "/image/edit/:imageId",
    editById: (imageId: string) => `/image/edit/${imageId}`,
  },
  banner: {
    base: "/banner",
    view: "/banner/view",
    create: "/banner/create",
    edit: "/banner/edit/:bannerId",
    editById: (bannerId: string) => `/banner/edit/${bannerId}`,
  },
  preferenceCuisine: {
    base: "/preference-cuisine",
    view: "/preference-cuisine/view",
    create: "/preference-cuisine/create",
    edit: "/preference-cuisine/edit/:cuisineId",
    editById: (cuisineId: string) => `/preference-cuisine/edit/${cuisineId}`,
  },
  preferenceWatchItem: {
    base: "/preference-watch-item",
    view: "/preference-watch-item/view",
    create: "/preference-watch-item/create",
    edit: "/preference-watch-item/edit/:watchItemId",
    editById: (watchItemId: string) =>
      `/preference-watch-item/edit/${watchItemId}`,
  },
  figma: {
    base: "/figma",
    view: "/figma/view",
  },
  figmaHealthMonitor: {
    base: "/figmaHealthMonitor",
    view: "/figmaHealthMonitor/view",
  },
  figmaTemplate: {
    base: "/figma-template",
    view: "/figma-template/view",
    create: "/figma-template/create",
    edit: "/figma-template/edit/:figmaTemplateId",
    editById: (figmaTemplateId: string) =>
      `/figma-template/edit/${figmaTemplateId}`,
  },
  variables: {
    base: "/variables",
    view: "/variables/view",
  },
  emailNotifications: {
    base: "/emailNotifications",
    view: "/emailNotifications/view",
  },
  shoppingListReport: {
    base: "/shoppingListReport",
    view: "/shoppingListReport/view",
  },
  adminUserSettings: {
    base: "/adminUserSettings",
    view: "/adminUserSettings/view",
  },
  recommendationEngine: {
    base: "/recommendationEngine",
    view: "/recommendationEngine/view",
  },
  analytics: {
    base: "/analytics",
    view: "/analytics/view",
  },
  createDeal: {
    base: "/createdeal",
    view: "/createdeal/view",
    create: "/createdeal/create",
    previous: "/createdeal/previousdeal",
    edit: "/createdeal/edit/:promotionId",
    editById: (promotionId: string) => `/createdeal/edit/${promotionId}`,
  },
  dynamic: {
    viewForGroup: (groupName: string) => `/${groupName}/view`,
  },
} as const;
